import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { SapC4CLinkedService } from 'app/model/linkedservice/sapc4c.linkedservice';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapC4CLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                url: '*',
                username: '*',
                password: 'secret',
                encryptedCredential: '*'
            }
        }
    }
})
export class SapC4CLinkedServiceAdapter extends LinkedServiceAdapter<SapC4CLinkedService> {
    protected modelConstructor(): new () => SapC4CLinkedService {
        return SapC4CLinkedService;
    }

    protected model(): IModel {
        return SapC4CLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: SapC4CLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.SapCloudForCustomerLinkedService;
        properties.type = Metamodel.modelFor(SapC4CLinkedService).name;
        const password: Model.SecretBase = passwordOrAKVtoSecretBase(linkedService.password, this.context);
        properties.typeProperties = {
            url: linkedService.url,
            username: linkedService.username,
            password
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: SapC4CLinkedService): Promise<SapC4CLinkedService> {
        const prop = linkedServiceResource.properties as Model.SapCloudForCustomerLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.SapCloudForCustomerLinkedServiceTypeProperties = prop.typeProperties;

        linkedService.url = typeProperties.url;
        linkedService.username = typeProperties.username;
        linkedService.password = secretBaseToPasswordOrAKV(typeProperties.password, true, this.context);
        return linkedService;
    }
}
